export enum AxisType {
  X = 'x',
  Y = 'y',
}
